// Mobile nav
document.addEventListener('click', function(event)
{
	const element = event.target
	if (element.matches('#burger_icon'))
	{
		document.querySelector('header').classList.add('open_nav')
	}
	else if (element.matches('#close_nav_icon'))
	{
		document.querySelector('header').classList.remove('open_nav')
	}
})

// Click a company logo to show more details
document.addEventListener('click', function(event)
{
	const element = event.target
	if (element.matches('.show_company_details_button'))
	{
		const company_thumb = element.closest('.company_thumb')

		const logo = company_thumb.getAttribute('data-logo')
		const company_name = company_thumb.getAttribute('data-company-name')
		const industry = company_thumb.getAttribute('data-industry')
		const website = company_thumb.getAttribute('data-website')
		const company_details = company_thumb.getAttribute('data-company-details')

		const company_modal_wrapper = document.querySelector('#company_modal_wrapper')

		company_modal_wrapper.querySelector('.logo').src = logo
		company_modal_wrapper.querySelector('.company_name').textContent = company_name
		company_modal_wrapper.querySelector('.industry').textContent = industry
		company_modal_wrapper.querySelector('.website').textContent = website
		company_modal_wrapper.querySelector('.company_details').innerHTML = company_details

		company_modal_wrapper.classList.add('visible')
	}
})

// Close company modal
document.addEventListener('click', function(event)
{
	const element = event.target
	if (element.matches('#close_company_modal_button'))
	{
		const company_modal_wrapper = document.querySelector('#company_modal_wrapper')
		company_modal_wrapper.classList.remove('visible')
	}
})
